export const Z_INDEX = {
  drawer: 1050,
} as const;
